module.exports = __webpack_public_path__ + "static/img/banner_1.8646816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner_1.jpg
// module id = BDjA
// module chunks = 0